export default __webpack_public_path__ + "static/media/flag-sicily.7f13af66.svg";